import { APIMethod, fetchData } from "@client";

export async function changeProjectDescriptionQuery(uuid, description) {
  const data = { uuid, description };
  await fetchData("/project/description ", APIMethod.POST, { data });
}
